import builder from '../builder';
import HotelSingleBedAdd from '../../streamline-icons/light/hotel-single-bed-add.svg';

export default builder('IconHotelSingleBedAddLight', HotelSingleBedAdd);
